import { DB_REF, DbLessonStat, DbWeaknessStat, WeaknessStat } from 'interface/database'

import { unSanitizeFirebaseKey } from './un-sanitize-firebase-key'

export const convertFirebaseData = (data: DbLessonStat | DbWeaknessStat, dbRef: DB_REF) => {
  if (data === null) return null

  if (dbRef === DB_REF.stats) {
    return data as DbLessonStat
  }

  if (
    dbRef === DB_REF.uppercase ||
    dbRef === DB_REF.lowercase ||
    dbRef === DB_REF.num ||
    dbRef === DB_REF.punctuation ||
    dbRef === DB_REF.ngBi ||
    dbRef === DB_REF.ngTri ||
    dbRef === DB_REF.ng4 ||
    dbRef === DB_REF.cw1_50 ||
    dbRef === DB_REF.cw51_100 ||
    dbRef === DB_REF.cw101_150 ||
    dbRef === DB_REF.cw151_200 ||
    dbRef === DB_REF.cw201_250 ||
    dbRef === DB_REF.cw251_300 ||
    dbRef === DB_REF.cw301_400 ||
    dbRef === DB_REF.cw401_500 ||
    dbRef === DB_REF.cw501_600 ||
    dbRef === DB_REF.cw601_700 ||
    dbRef === DB_REF.cw701_800 ||
    dbRef === DB_REF.cw801_900 ||
    dbRef === DB_REF.cw901_1000
  ) {
    const dbData = data as DbWeaknessStat

    return Object.entries(dbData).reduce((weaknessStat: WeaknessStat, [key, value]) => {
      weaknessStat[dbRef === DB_REF.punctuation ? unSanitizeFirebaseKey(key) : key] = Object.values(value)
      return weaknessStat
    }, {})
  }

  throw new Error('Invalid dbRef, should not reach here.')
}
